import { render, staticRenderFns } from "./ModalStylePageLayout.vue?vue&type=template&id=48f71ec7&scoped=true&lang=pug&"
import script from "./ModalStylePageLayout.vue?vue&type=script&lang=ts&"
export * from "./ModalStylePageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStylePageLayout.vue?vue&type=style&index=0&id=48f71ec7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f71ec7",
  null
  
)

export default component.exports